import { ReactNode, useEffect } from "react";

const ValidateAppNetwork = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    const cleanUpServiceWorker = () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .getRegistrations()
          .then((regs) => Promise.all(regs.map((r) => r.unregister())))
          .then(() => {
            if (window.caches) {
              caches
                .keys()
                .then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
            }
          })
          .catch(() => {});
      }
    };

    cleanUpServiceWorker();
  }, []);

  return <>{children}</>;
};
export default ValidateAppNetwork;
